/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, ComponentRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewContainerRef, inject } from '@angular/core';
import { ControlOn, AppFormControl } from '@src/app/shared/form/app-form-control';
import { FormControlInterface } from '@src/app/shared/form/form-control-interface';
import { GridControl } from '@src/app/shared/grid/grid-control';

@Component({
    selector: 'app-ctl-holder',
    template: ``,
    styleUrls: ['./ctl-holder.component.scss'],
    standalone: true
})
export class CtlHolderComponent implements OnChanges, OnDestroy {
    viewContainerRef = inject(ViewContainerRef);


    @Input() control: GridControl | AppFormControl;
    @Input() on: ControlOn = 'form';
    @Input() name: string;

    initialized = false;
    private componentRef: ComponentRef<FormControlInterface>

    /*
    * Switched to OnChanges because angular content project will always initialize content immediately
    * So even if content is inside an if statement, it gets initialized
    * So projected formContent initializes before the initComplete has been fired
    * This change allows the components to be rendered as the content gets controls get created.
    */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.control?.currentValue) {
            if (changes.control.previousValue) {
                console.warn('Control has changed', { holder: this, changes });
            }
            this.componentRef = this.control.field.formControlFactory(this.viewContainerRef, this.control, this.on);
        }
    }

    ngOnDestroy(): void {
        // Mandatory cleanup: Destroy the dynamically created component when the holder is destroyed
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }    
}
